import { Reservation } from '@app/models/micro/reservation.model';
import { AdminDataInt } from '@app/interfaces/admin.interface';
import { showCarryon } from './general';

/**
 * Determina si existe oferta de carry-on (incluido el add-on de 5kg) disponible
 * para la ruta y tarifa de la reservacion.
 *
 * Reutiliza la logica de showCarryon como unica fuente de verdad: valida
 * INTERNATIONALROUTES, que legRegion no sea 'USA', la familia tarifaria elegible
 * y la bandera isNewBF de la reservacion. La disponibilidad depende de la ruta,
 * la tarifa y la configuracion admin, no de los pasajeros seleccionados.
 *
 * @param reservation Reservacion actual con flightSummary.
 * @param admin Configuracion de admin del kiosko.
 * @returns true si hay oferta de carry-on disponible para esta ruta y tarifa.
 */
export function hasCarryOnOffersAvailable(reservation: Reservation, admin: AdminDataInt): boolean {
  if (!reservation || !admin) {
    return false;
  }

  return showCarryon(reservation, admin);
}
